import api from "../login/interceptors";
import { BASE_URL } from "../../Constants";

export const handleLogout = async (redirect) => {
  try {
    await api.post(`${BASE_URL}/api/logout/`, {});
  } catch (error) {
    console.error('Logout failed:', error);
  }
  localStorage.clear();
  // Click handlers pass the event; only an in-app path should override the default.
  const next = typeof redirect === "string" && redirect.startsWith("/") ? redirect : "/login";
  window.location = next;
};
